import React, { Fragment, useState } from "react";
import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { useEffect } from 'react';

const Checkout = () => {
  const [amounta, setAmount] = useState(100);
  const [loading, setLoading] = useState(false);

  const [depositInput, setDepositInput] = useState({
    amount: amounta,
    password: '',
    error_list: [],
  });

  const handleIncrement = () => {
    setAmount(prev => prev + 100);
    setDepositInput(prevState => ({
      ...prevState,
      amount: Math.max(prevState.amount + 100, 100),
    }));
  };

  const handleDecrement = () => {
    setAmount(prev => Math.max(prev - 100, 100));
    setDepositInput(prevState => ({
      ...prevState,
      amount: Math.max(prevState.amount - 100, 100),
    }));
  };

  const handleInput = (e) => {
    setDepositInput({ ...depositInput, [e.target.name]: e.target.value });
  };

  const depositSubmit = (e) => {
    e.preventDefault();
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      amount: depositInput.amount,
      password: depositInput.password,
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9'
    };
    if (auth_token !== null && !loading) {
      setLoading(true);
      axios.post(`/sub-invest`, data).then(res => {
        if (res.data.status === 'success') {
          swal("Success", res.data.message, "success");
          setDepositInput({ amount: '', password: '', error_list: [] });
        } else if (res.data.status === 'fail') {
          swal("Warning", res.data.message, "warning");
        } else {
          setDepositInput({ ...depositInput, error_list: res.data.validation_error });
        }
        setLoading(false);
      });
    }
  };


  const [user, setUser] = useState([]);
    useEffect(()=>{
      const auth_token = localStorage.getItem('auth_token');
      const selectedCurrency = localStorage.getItem('selectedCurrency');
        const data = {
            key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
            currency: selectedCurrency,
        }
      if (auth_token !== null) {
         axios.post('/apps-profile',data)
         .then(response=>{
           setUser(response.data)
           console.log(response.data)
           
           })
           .catch(error=>{
             console.log(error)
         })
      }

    },[])


  let reserve_balance;
  if (user == "") {
    console.log(user);
  }else{
    reserve_balance=user.data.reserve_balance;
  }

  return (
    <Fragment>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card border-0 shadow rounded-4">
              <div className="card-body p-5">
                <div className="row">
                  {/* Left Section */}
                  <div className="col-md-5 border-end mb-4 mb-md-0">
                  <button
                    className="btn btn-lg w-100 text-white d-flex align-items-center justify-content-center gap-2 shadow mb-3"
                    style={{
                      background: "#002f6a",
                      borderRadius: "14px",
                      transition: "0.3s",
                    }}
                  >
                    <i className="fa fa-wallet fs-4"></i>
                    <span className="fs-3 fw-bold">Balance:  ${Number(reserve_balance).toFixed(2)}</span>
                  </button>
                    <h5 className="text-primary mb-4">Investment Summary</h5>
                    <ul className="list-unstyled">
                      <li className="mb-3">
                        <strong>Security:</strong> <span className="text-success float-end">100%</span>
                        <small className="d-block text-muted">Ensuring a Safe and Secure Investment</small>
                      </li>
                      <li className="mb-3">
                        <strong>Amount:</strong> <span className="text-success float-end">${depositInput.amount}</span>
                        <small className="d-block text-muted">Total Investment Payment</small>
                      </li>
                      <li>
                        <strong>Join Us:</strong>
                        <small className="d-block text-muted">Join Our Vibrant Investment Today!</small>
                      </li>
                    </ul>
                  </div>

                  {/* Right Section */}
                  <div className="col-md-7">
                  
                    <h4 className="mb-4">Join Investment</h4>
                    <form onSubmit={depositSubmit}>
                      <div className="mb-3">
                        <label className="form-label">Select Amount</label>
                        <div className="input-group">
                          <button className="btn btn-outline-secondary" type="button" onClick={handleDecrement}>-</button>
                          <input
                            type="text"
                            className="form-control text-center"
                            name="amount"
                            value={depositInput.amount}
                            onChange={handleInput}
                            placeholder="Enter Amount"
                          />
                          <button className="btn btn-outline-secondary" type="button" onClick={handleIncrement}>+</button>
                        </div>
                        <small className="text-danger">{depositInput.error_list.amount}</small>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Account Password</label>
                        <input
                          type="password"
                          name="password"
                          value={depositInput.password}
                          onChange={handleInput}
                          className="form-control"
                          placeholder="Enter your account password"
                        />
                        <small className="text-danger">{depositInput.error_list.password}</small>
                      </div>

                      <div className="form-check mb-4">
                        <input type="checkbox" className="form-check-input" id="terms" required />
                        <label className="form-check-label" htmlFor="terms">
                          I agree to the terms and conditions
                        </label>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary w-100 py-2"
                        disabled={loading}
                      >
                        {loading ? "Processing..." : "Invest Now"}
                      </button>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Checkout;
